import React, { useEffect, useState } from 'react';
import Logo from '../assets/logo-sarovar.svg';
import { Input, Select, Table, Button } from 'antd';
import { SearchOutlined, DownloadOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { getVisitorHistory } from '../services/apiservice';
import { useHotel } from '../context/HotelContext';
import { HOTELS_IMAGE_ROOT_URL } from '../constant';
import moment from 'moment';
import lodash from 'lodash';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

// {
//     title: 'Age',
//     dataIndex: 'age',
//     key: 'age',
// },
// {
//     title: 'Meal Type',
//     dataIndex: 'meal_type',
//     key: 'meal_type',
// },
// {
//     title: 'Guest Type',
//     dataIndex: 'guest_type',
//     key: 'guest_type',
// },
// {
//     title: 'Note',
//     dataIndex: 'note',
//     key: 'note',
// },
const columns = [
    {
        title: <div className='text-center'>Name</div>,
        render: (record) => {
            return (
                <p className='table-cell-highlighter'>{`${record.title} ${record.name}`}</p>
            );
        },
        key: 'name',
        fixed: 'left',
        width: 150,
    },
    {
        title: <div className='text-center'>Last Visit</div>,
        render: (record) => {
            return (
                <p className='table-cell-highlighter'>
                    <p>
                        {moment
                            .utc(record.created_at)
                            .local()
                            .format('YYYY-MM-DD hh:mm')}
                    </p>
                </p>
            );
        },
        key: 'created_at',
        width: 150,
    },
    {
        title: <div className='text-center'>Mobile</div>,
        key: 'mobile',
        render: (record) => {
            return <p className='table-cell-highlighter'>{record.mobile}</p>;
        },
        width: 130,
    },

    {
        title: <div className='text-center'>Email</div>,
        dataIndex: 'email',
        key: 'email',
        width: 230,
    },
    {
        title: 'Birthday',
        key: 'dob',

        render: (record) => {
            return record.dob ? (
                <p>{new Date(record.dob).toLocaleDateString()}</p>
            ) : (
                '-'
            );
        },
        width: 120,
    },
    {
        title: 'Anniversary',
        key: 'anniversary_date',

        render: (record) => {
            return record.anniversary_date ? (
                <p>{new Date(record.anniversary_date).toLocaleDateString()}</p>
            ) : (
                '-'
            );
        },
        width: 120,
    },
    {
        title: 'No of Guests',
        key: 'no_of_packs',
        render: (record) => {
            return record.no_of_packs ? <p className='text-center'>{record.no_of_packs}</p> : '-';
        },
        width: 120,
    },
    {
        title: <div className='text-center'>Outlet Name</div>,
        render: (record) => {
            return record.outlet_name ? <p className='text-center'>{record.outlet_name}</p> : '-';
        },
        key: 'outlet_name',
        width: 120,
    },
    // {
    //     title: <div className='text-center'>Visitor</div>,
    //     key: 'visit_type',
    //     render: (record) => {
    //         return (
    //             <p className='table-cell-highlighter'>{record.visit_type}</p>
    //         );
    //     },
    //     width: 130,
    // },
];
const History = () => {
    const navigate = useNavigate();
    const [searchValue, setSearchValue] = useState('');
    const [historyData, setHistoryData] = useState([]);
    const { hotelDetails, isMobileView } = useHotel();
    const [outeletList, setOuteletList] = useState([]);
    const [selectedOutelet, setSelectedOutelet] = useState(null);

    useEffect(() => {
        const { outlets } = hotelDetails || {};
        if (outlets?.length > 0) {
            let mealList = [
                { label: 'All Restaurants', value: null },
                ...outlets
                    .filter((item) => Boolean(item.enabled))
                    .map((item) => ({ label: item.name, value: item.id })),
            ];
            setOuteletList(mealList);
        }
    }, [hotelDetails]);

    useEffect(() => {
        fetchVisitorHistory();
    }, [searchValue, selectedOutelet]);

    const fetchVisitorHistory = async () => {
        try {
            const response = await getVisitorHistory(
                searchValue,
                selectedOutelet
            );

            if (response?.status === 200) {
                const result = response.data || {};
                const list = result.data || [];
                setHistoryData(list);
            }
        } catch (error) {}
    };

    console.log(historyData);
    let debounce_fun = lodash.debounce(fetchVisitorHistory, 1000);

    const downloadAsExcel = () => {
        // Map contactBookData to match the required columns and default values
        const formattedData = historyData.map((record) => ({
            Guest_Name: `${record.title} ${record.name}`,
            Booking_Source_Name: 'ViralOps',
            Booking_Date: record?.created_at
                ? new Date(record.created_at).toLocaleDateString()
                : '-',
            Check_In_Date: record?.created_at
                ? new Date(record.created_at).toLocaleDateString()
                : '-',
            Check_Out_Date: record?.created_at
                ? new Date(record.created_at).toLocaleDateString()
                : '-',
            Email_Id_1: record?.email || '-',
            Email_Id_2: '-',
            Mobile_Number_1: record?.mobile || '-',
            Mobile_Number_2: '-',
            Entity_Name: record?.outlet_name || '-',
            Entity_ID: record?.outlet_id || '-',
            Birthday: record?.dob
                ? new Date(record.dob).toLocaleDateString()
                : '-',
            Anniversary: record?.anniversary_date
                ? new Date(record.dob).toLocaleDateString()
                : '-',
        }));

        // Generate worksheet and rename headers
        const worksheet = XLSX.utils.json_to_sheet(formattedData);

        // Define custom header names for the worksheet columns
        XLSX.utils.sheet_add_aoa(
            worksheet,
            [
                [
                    'Guest_Name',
                    'Booking_Source_Name',
                    'Booking_Date(YYYY-MMM-DD)',
                    'Check_In_Date(YYYY-MMM-DD)',
                    'Check_Out_Date(YYYY-MMM-DD)',
                    'Email_Id_1',
                    'Email_Id_2',
                    'Mobile_Number_1',
                    'Mobile_Number_2',
                    'Entity_Name',
                    'Entity_ID',
                    'Birthday',
                    'Anniversary',
                ],
            ],
            { origin: 'A1' }
        ); // Add headers at the first row (A1)

        // Create workbook and save as Excel file
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'AddressBook');

        const excelBuffer = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
        });
        const data = new Blob([excelBuffer], {
            type: 'application/octet-stream',
        });
        saveAs(data, 'AddressBook.xlsx');
    };

    return (
        <div className='outlet-screen bg-img min-h-dvh flex flex-col justify-start items-center px-4 pb-4'>
            <div className='head-section w-full z-10 flex justify-center items-center flex-row  py-3 relative md:justify-center md:flex-col md:py-5'>
                <div
                    className='back-btn absolute '
                    onClick={() => navigate(-1)}
                ></div>
                {hotelDetails.logo && (
                    <img
                        src={`${HOTELS_IMAGE_ROOT_URL}${hotelDetails.logo}`}
                        alt='logo'
                        className='max-w-20 md:max-w-60'
                        onClick={() => navigate('/', { replace: true })}
                    />
                )}
                <Button
                    onClick={downloadAsExcel}
                    className='download-btn absolute'
                >
                    <DownloadOutlined />
                </Button>
            </div>
            <div className='guest-form-heading pt-2 pb-8'>
                Visitor's History
            </div>
            <div className='guest-form w-full flex flex-col gap-4 p-2 justify-start items-start md:p-6'>
                <div className='search-wrapper flex justify-start items-center gap-2 flex-col md:flex-row md:gap-4'>
                    <Input
                        prefix={
                            <SearchOutlined
                                style={{
                                    fontSize: '1.25rem',
                                    color: 'grey',
                                }}
                            />
                        }
                        value={searchValue}
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            debounce_fun(e.target.value);
                        }}
                        size='large'
                        placeholder='Search by name/mobile'
                        className='rounded-lg border-gray-300 p-2 flex-1 min-h-12 w-56'
                    />
                    <div className='staff-container '>
                        <Select
                            onChange={(value) => setSelectedOutelet(value)}
                            value={selectedOutelet}
                            options={outeletList}
                            className='rounded-xl  border-gray-300 bg-gray-100 w-56 min-h-12 '
                            size={isMobileView ? 'small' : 'large'}
                        ></Select>
                    </div>
                </div>
                <div className='w-full'>
                    <Table
                        dataSource={historyData}
                        columns={columns}
                        scroll={{
                            x: 800,
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default History;
